import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './SearchInput.module.css';

const SearchInput = ({ value, onChange, placeholder = 'Поиск...' }) => (
  <Form.Control
    type="search"
    className={styles.input}
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);

export default SearchInput;

